import { Component, Input } from '@angular/core';
import { OmniChatFacade } from '@cigna/omni/chat-state';
import { OmniConversationsFacade } from '@cigna/omni/conversations-state';

@Component({
  selector: 'cigna-omni-messaging-disclaimer',
  templateUrl: './disclaimer.component.html',
  styleUrls: ['./disclaimer.component.scss'],
})
export class OmniMessagingDisclaimerComponent {
  @Input() public shouldEnableNewChat: boolean;
  @Input() public shouldEnablePreChatWelcome: boolean;
  @Input() public isHistory: boolean;
  @Input() public disclaimer: string;
  @Input() public isHistoryLinkEnable: boolean;
  @Input() public isUpdatingConversation: boolean;
  public historyLabel = 'Looking for older conversations?';
  public historyButtonText = 'View Chat History';

  constructor(
    private chatFacade: OmniChatFacade,
    private conversationsFacade: OmniConversationsFacade,
  ) {}

  public openHistory() {
    this.chatFacade.openHistory();
    this.conversationsFacade.getConversationHistory();
    this.conversationsFacade.setHeaderFocus(true);
  }
}
